"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var r = n(e),
    a = function a(e) {
  var n = e.files,
      a = r.useContext(t.LocalizationContext);
  return 0 === n.length ? r.createElement("div", {
    className: "rpv-attachment-list-empty"
  }, a && a.attachment ? a.attachment.noAttachment : "There is no attachment") : r.createElement("ul", {
    className: "rpv-attachment-list"
  }, n.map(function (e) {
    return r.createElement("li", {
      className: "rpv-attachment-item",
      key: "attachment-" + e.fileName,
      title: a && a.attachment ? a.attachment.clickToDownload : "Click to download",
      onClick: function onClick() {
        return t = e.fileName, n = e.data, r = "string" == typeof n ? "" : URL.createObjectURL(new Blob([n], {
          type: ""
        })), (a = document.createElement("a")).style.display = "none", a.href = r || t, a.setAttribute("download", function (e) {
          var t = e.split("/").pop();
          return t ? t.split("#")[0].split("?")[0] : e;
        }(t)), document.body.appendChild(a), a.click(), document.body.removeChild(a), void (r && URL.revokeObjectURL(r));
        var t, n, r, a;
      }
    }, e.fileName);
  }));
},
    c = function c(e) {
  var n = e.doc,
      c = r.useState({
    files: [],
    isLoaded: !1
  }),
      o = c[0],
      i = c[1];
  return r.useEffect(function () {
    n.getAttachments().then(function (e) {
      var t = e ? Object.keys(e).map(function (t) {
        return {
          data: e[t].content,
          fileName: e[t].filename
        };
      }) : [];
      i({
        files: t,
        isLoaded: !0
      });
    });
  }, [n]), o.isLoaded ? r.createElement(a, {
    files: o.files
  }) : r.createElement(t.Spinner, null);
},
    o = function o(e) {
  var n = e.store,
      a = r.useState(n.get("doc")),
      o = a[0],
      i = a[1],
      u = function u(e) {
    i(e);
  };

  return r.useEffect(function () {
    return n.subscribe("doc", u), function () {
      n.unsubscribe("doc", u);
    };
  }, []), o ? r.createElement(c, {
    doc: o
  }) : r.createElement("div", {
    className: "rpv-attachment-list-loader"
  }, r.createElement(t.Spinner, null));
};

exports.attachmentPlugin = function () {
  var e = r.useMemo(function () {
    return t.createStore({});
  }, []);
  return {
    onDocumentLoad: function onDocumentLoad(t) {
      e.update("doc", t.doc);
    },
    Attachments: function Attachments() {
      return r.createElement(o, {
        store: e
      });
    }
  };
};